import { appRouterPaths } from "@/services/navigation";
import { CheckPaymentPage } from "@/pages/RegistrationPage/Components/CheckPayment";
import type { RouteProps } from "react-router-dom";

export const checkPaymentPageRoute: RouteProps = {
  path: appRouterPaths.checkPayment,
  element: <CheckPaymentPage />,
};
